<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjProgressDisplay',
})
</script>
<template>
  <Descriptions layout="vertical" :column="1" size="middle">
    <Descriptions.Item v-for="item in steps" :label="item.label">
      <ProjProcessStatus :value="result[item.value]" />
    </Descriptions.Item>
  </Descriptions>
</template>

<script lang="ts" setup name="ProjProgressDisplay">
import { Descriptions } from 'ant-design-vue'
import { ProjProcessStatus } from '-/Business/Status'
import { useDetailLy } from '@/hooks/useDetailLy'
withDefaults(
  defineProps<{
    steps?: BaseOption<string>[]
  }>(),
  {
    steps: () => []
  }
)
const { result } = useDetailLy()
</script>
